import React from 'react';
import { connect } from 'react-redux';
import { EnvType } from "./constants";
import Logger from '../../functions/logging';
import LOLOMO from './lolomo';

class AppleTVPlusThemedRow extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			scrollPosition: 0,
			indicatorIdx: 0
		};

		this.getBillboardInfo = this.getBillboardInfo.bind(this);
	}

	getBillboardInfo(asset, videoKey, fullAssetRow, group) {
		let billboardAssetID;
		for (let asset_id in fullAssetRow) {
			const asset = fullAssetRow[asset_id];
			if (asset.original_theme) {
				billboardAssetID = asset._id;
			}
		}
		const billboardInfo = fullAssetRow && billboardAssetID && fullAssetRow[billboardAssetID];
		const rowTitle = videoKey && (videoKey.split("_")[0]);
		const rowId = videoKey && (videoKey.split("_")[1]);

		const rows = group && group.svod_env && group.svod_env.appletv_plus_rows || [];
		const currentRow = rows.find((row) => row.label === rowTitle && row.description);

		return { billboardInfo, rowTitle, rowId, rowDescription: currentRow && currentRow.description };
	}

	getAppleTVPlusThemedRow(currentAsset, appleTVVideoRows) {
		Logger.log(this.constructor.name, "getAppleTVPlusThemedRow()", currentAsset, appleTVVideoRows);
		if (appleTVVideoRows && currentAsset && currentAsset._id) {
			const rowInformation = [];
			for (let videoKey in appleTVVideoRows) {
				const appleTVPlusAssets = appleTVVideoRows[videoKey];

				if (appleTVPlusAssets[currentAsset._id]) {
					const includedAppleTVPlusVideos = {};

					for (let assetID in appleTVPlusAssets) {
						const asset = appleTVPlusAssets[assetID];
						if (asset._id !== currentAsset._id 
							&& (asset.licensed || asset.original_theme)
							&& !asset.transactional
						) {
							includedAppleTVPlusVideos[assetID] = asset;
							rowInformation.push(asset);
						}
					}
					return { videoKey, rowInformation, assetRow: includedAppleTVPlusVideos, fullAssetRow: appleTVPlusAssets};
				}
			}
		}
		return {};
	}
    
	render() {
		const { asset, appleTVVideos, fetchedGroup } = this.props;
		const rowInformation = fetchedGroup && fetchedGroup.svod_env && fetchedGroup.svod_env.appletv_plus_rows;
		const { assetRow, videoKey, fullAssetRow } = this.getAppleTVPlusThemedRow(asset, appleTVVideos);
		const { billboardInfo, rowTitle, rowDescription } = this.getBillboardInfo(asset, videoKey, fullAssetRow, fetchedGroup);
		const rowContainsAssets = assetRow ? !!Object.keys(assetRow).length : false;
		const billboardImage = billboardInfo && (billboardInfo.images.highlight || billboardInfo.images.background || billboardInfo.images.billboard_wide);
		const displayWidgetBanner = rowContainsAssets
			&& billboardInfo
			&& (billboardInfo.original_theme || billboardInfo.licensed)
			&& billboardImage;
		
		return (
			<div className='dynamic-billboard-wrapper'>
				{displayWidgetBanner ? 
					<div className='included-appletv-plus-widget'>
						<img id='dynamic-billboard-image'
							className="widget-banner width-100p"
							src={billboardImage}
						/>

						<div className='billboard-details-wrapper'>
							<p className='widget-title'>INCLUDED WITH APPLE TV+</p>
							{rowTitle && <h5>{rowTitle}</h5>}
							{rowDescription && <p className='widget-description'>{rowDescription}</p>}
						</div>
						
						{assetRow ? 
							<LOLOMO {...this.props}
								videos={assetRow}
								activeDropdown={{}}
								rowIndex={0}
								row_type='thumbnail'
								rowInfoObject={assetRow}
								rowInformation={rowInformation}
								label={videoKey}
								key={`lolomo`}
								magnifyDisabled={true}
								disableRowTitle={true}
								pageLocation='show_page_original_theme'
								source_asset_name={this.props.asset.name}
								source_asset_id={this.props.asset._id}
							/>
							: ''
						}
					</div>
					: ''
				}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	videos: state.SVOD.videos,
	appleTVVideos: state.SVOD.appleTVVideos,
	environment: state.SVOD.environment,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
});

export default connect(mapStateToProps, {})(AppleTVPlusThemedRow);


// WEBPACK FOOTER //
// ./src/components/svod/AppleTVPlusThemedRow.js